<template>
    <div class="w-100 h-100 d-flex flex-column">
        <table-filter v-if="!noQueryInput" :fields="visibleFields" class="mb-1"
                      @change="whenSearchChange"
                      :search-loading="queryLoading"
                      @search="whenSearchClick"></table-filter>
        <div class="flex-grow-1 overflow-auto" style="min-height: 300px">
            <mini-table ref="_miniTable"
                        v-bind="$attrs"
                        read-only
                        :entity-name="$_configCode"
                        :items="rows"
                        :fields="visibleFields"
                        :loading="formLoading"
                        filterable
                        disable-first-index-column
                        :enable-row-check="!disableRowCheck"
                        enable-pagination
                        :total-count="totalCount"
                        :total-loading="countLoading"
                        @pageChange="whenPageChange"
                        sort-query
                        @sortChange="whenSortChange"
                        @rowChecked="whenRowChecked"
                        @linkClick="$emit('linkClick', $event)">
                <template #rightHeader>
                    <slot name="rightHeader"></slot>
                    <mini-button v-if="noQueryInput" :loading="queryLoading" @btnClick="whenSearchClick">
                        搜索
                    </mini-button>
                    <excel-import-btn v-if="enableImport" :service="service" :config-id="configId"
                                      :form-name="importFormName" :save-holder="importSaveHolder || newRowSaveHolder"
                                      @success="queryRows"/>
                    <excel-export-btn v-if="!disableExport" :service="service" :config-id="configId"
                                      :filter="mergedQueryForm"></excel-export-btn>
                </template>
                <template #headOfRow="{row}">
                    <slot name="headOfRow" :row="row"></slot>
                </template>
                <template #leftHeader>
                    <template v-if="enableEdit">
                        <mini-button v-if="disableEditBtn%2!==0" name="add" @btnClick="openEditForm(true)">
                            <i class="fa-solid fa-plus"></i>
                        </mini-button>
                        <mini-button v-if="disableEditBtn%3!==0" :disable="$_notCheckedOne" name="edit" @btnClick="openEditForm(false)">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </mini-button>
                        <delete-button v-if="disableEditBtn%5!==0" :loading="deleteLoading" :disable="$_notChecked" name="delete"
                                       variant="outline-primary"
                                       @btnClick="deleteRows"></delete-button>
                    </template>
                    <slot name="leftHeader"></slot>
                </template>
                <template v-for="name of slotNames" v-slot:[name]="{row}">
                    <slot :name="name" :row="row"></slot>
                </template>
            </mini-table>

            <re-b-modal ref="editForm" header="Edit" hide-footer>
                <formula-form v-if="enableEdit && editFormConfig.length>0"
                              :fields="editFormConfig"
                              :item="currentEditRow"
                              submit-label="保存"
                              :enable-submit-continuous="editNew"
                              submit-continuous-label="保存并继续"
                              :loading="saveLoading"
                              @submit="saveRow"
                              @submitContinuous="saveRow($event, true)"></formula-form>
                <div v-else>
                    未配置，请联系相关人员
                </div>
            </re-b-modal>
        </div>
    </div>

</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import TableSearch from "@/components/common/inputs/table-search/TableSearch.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import FormulaForm from "@/components/common/inputs/FormulaForm.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import queryViewEditMixin from "@/components/common/display/query-view/mixin/query-view-edit-mixin";
import excelOperateMixin from "@/components/common/display/query-view/mixin/excel-operate-mixin";
import ExcelImportBtn from "@/components/common/display/query-view/stuff/ExcelImportBtn.vue";
import ExcelExportBtn from "@/components/common/display/query-view/stuff/ExcelExportBtn.vue";
import TableFilter from "@/components/common/inputs/table-search/TableFilter.vue";

export default {
    name: "QueryView",
    mixins: [queryViewEditMixin, excelOperateMixin],
    components: {
        TableFilter,
        ExcelExportBtn,
        ExcelImportBtn,
        DeleteButton,
        FormulaForm,
        ReBModal,
        TableSearch,
        MiniButton,
        MiniTable
    },
    props: {
        configCode: String,
        useConfigId: [Number, String],
        filter: Object,
        noQueryInput: {
            type: Boolean,
            default: false
        },
        skipPathQuery: {
            type: Boolean,
            default: false
        },
        disableRowCheck: Boolean,
        fieldAddition: Object,
    },
    data() {
        return {
            baseConfigUri: process.env.VUE_APP_EM_ASSISTANT_URL + "/qg",
            i18nLoading: false,
            formLoading: false,
            queryLoading: false,
            originalFields: [],
            fields: [],
            rows: [],
            service: null,
            configId: null,
            currentPage: {
                pageNumber: 0,
                pageSize: 20,
            },
            countLoading: false,
            totalCount: 0,
            orders: [],

            queryForm: {},
            queryChange: false,

            slotNames: [],
            needInitQuery: false,
        }
    },
    computed: {
        $_configCode() {
            return this.configCode || 'qv-code-' + this.useConfigId;
        },
        needReTransCode() {
            if (this.$store.state.queryViewStore.reloadFlag) {
                //
            }
            let set = this.$store.state.queryViewStore.needUpdateCode;
            return set.has(this.$_configCode);
        },
        visibleFields() {
            let temp = [];
            for (let item of this.fields) {
                if (item.visible) {
                    if (this.fieldAddition && item.key in this.fieldAddition) {
                        this.copyObj2Obj(this.fieldAddition[item.key], item);
                    }
                    temp.push(item);
                }
            }
            return temp;
        },
        mergedQueryForm() {
            return this.getQueryForm();
        },
    },
    watch: {
        needReTransCode() {
            if (this.needReTransCode) {
                this.initPage();
                this.$store.commit('queryViewStore/finish', this.configCode);
            }
        },
    },
    mounted() {
        this.initPage();
        this.slotNames = this.$refs._miniTable.slotNames();
    },
    methods: {
        initPage() {
            let code = this.configCode;
            if (this.hasCode(code)) {
                this.$queryIdByCode(code).then(res => {
                    this.service = res.service;
                    this.configId = res.id;
                    if (this.configId) {
                        this.getFullForm();
                        this.queryRows();
                        this.countRows();
                    }
                });
            } else if (this.hasCode(this.useConfigId)) {
                this.configId = this.useConfigId;
                this.needInitQuery = true;
                this.getFullForm();
            } else {
                this.$message.warning("Error");
                return false;
            }
            return code;
        },
        getFullForm() {
            let key = 'query_view_form_' + this.configId;
            let localValue = localStorage[key];
            let lastTime = null;
            if (localValue) {
                let temp = JSON.parse(localValue);
                if (temp instanceof Array) {//兼容低版本
                    this.fields = temp;
                } else {
                    lastTime = temp.lastModifyTime;
                    this.readForm(temp);
                }
            } else {
                this.formLoading = true;
            }
            this.$store.dispatch('api/post', {
                url: `${this.baseConfigUri}/view/full`,
                data: {
                    id: this.configId,
                    lastModifyTime: lastTime
                }
            }).then(res => {
                if (res && res.data) {
                    this.readForm(res.data);
                    localStorage[key] = JSON.stringify(res.data);
                }
            }).finally(() => this.formLoading = false);
        },
        readForm(res) {
            let form = res.form;
            if (form) {
                this.fields = form;
            }
            this.editFormMap = res.editForms;
            let i18n = res.i18n;
            let kp = res.keyPrefix;
            if (i18n && kp) {
                for (let lang in i18n) {
                    let temp = {};
                    for (let k in i18n[lang]) {
                        temp[kp + k] = i18n[lang][k];
                    }
                    this.$i18n.add(lang, temp);
                }
            }
            if (this.needInitQuery) {
                this.service = res.service;
                this.queryRows();
                this.countRows();
            }
        },
        queryRows() {
            if (this.service) {
                this.queryLoading = true;
                let page = {
                    orders: this.orders,
                };
                this.copyObj2Obj(this.currentPage, page, true);
                this.$query({
                    service: this.service,
                    id: this.configId,
                    where: this.getQueryForm(),
                    page: page
                }).then(res => {
                    this.rows = res.data;
                    this.$nextTick(() => {
                        this.$store.commit('queryViewStore/setCurrentRows', {
                            code: this.$_configCode,
                            rows: this.rows
                        });
                        this.whenRowChecked([]);
                    });
                }).finally(() => this.queryLoading = false);
            }
        },
        countRows() {
            if (this.service) {
                this.countLoading = true;
                this.$query({
                    service: this.service,
                    id: this.configId,
                    where: this.getQueryForm(),
                    count: true
                }).then(res => {
                    this.totalCount = res.data;
                }).finally(() => this.countLoading = false);
            }
        },
        whenPageChange(page) {
            this.currentPage = page;
            this.queryRows();
        },
        whenSortChange(sort) {
            this.orders = [sort];
            this.queryRows();
        },
        whenSearchClick(form) {
            this.whenSearchChange(form);
            this.$nextTick(() => {
                if (this.fields && this.fields.length > 0) {
                    this.queryRows();
                    if (this.queryChange) {
                        this.countRows();
                        this.queryChange = false;
                    }
                } else {
                    this.initPage();
                }
            });
        },
        getQueryForm() {
            let temp = this.deepCopyObj(this.queryForm);
            if (!this.skipPathQuery) {
                let routeQuery = this.$route.query;
                for (let key of Object.keys(routeQuery)) {
                    let index = key.lastIndexOf("Filter");
                    if (index >= 0 && key.length - index === 6) {//end with
                        temp[key.substring(0, index)] = routeQuery[key];
                    }
                }
            }
            if (this.filter) {
                for (let key of Object.keys(this.filter)) {
                    temp[key] = this.filter[key];
                }
            }
            return temp;
        },

        whenSearchChange(form) {
            this.queryForm = form;
            this.queryChange = true;
        },
        whenRowChecked(ids) {
            this.$store.commit('queryViewStore/setCheckedIds', {
                code: this.$_configCode,
                ids: ids
            });
            this.$emit('rowChecked', ids);
        }
    },
    beforeDestroy() {
        this.$store.dispatch('queryViewStore/clear', this.$_configCode);
    }
}
</script>

<style scoped>

</style>
